module.exports = __webpack_public_path__ + "static/media/sf_attraction_cinema2.a02ae887.jpg";